<template>
    <div class="tags" v-if="tagSet && tagSet.length > 0">
        <ul style="width:100%;height:100%;">
            <li v-for="(route,index) of tagSet" :key="route.path" :style="{width:tagSet.length <= 12 || curHref === route.path?'8%':parseInt(100/tagSet.length)+'%'}" :class="curHref === route.path?'active':''">
                <div v-if="curHref === route.path" class="blue-hr"></div>
                <app-link :to="resolvePath(route.path)" :key="route.path">
                    <div class="title">
                        <p :class="[index == 0?'no-border':'','hr']"></p>
                        {{ route.title }}
                        <img @click.stop.prevent="removeRoute(route.path,index,route.name)" src="../../assets/icon_popclose_black@2x.png" />
                    </div>
                </app-link>
            </li>
        </ul>
    </div>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex'
import path from 'path'
import pathToRegexp from 'path-to-regexp'
import AppLink from '@/layout/components/Link'
import { setTimeout } from 'timers';
export default {
    name:'TagsViews',
    components: { AppLink },
    computed: {
		...mapGetters([
            'tagSet',
            'cachedViews',
            'tagId'
		])
    },
    data(){
        return {
            curHref:''
        }
    },
    created(){
        this.$store.dispatch('setAllTagInfo')
        this.$store.dispatch('addAllCachedView')
    },
    mounted(){
        this.curHref = this.$route.path
        this.addViewTags()
        this.addCacheViewTags()
    },
    watch:{
        tagSet(){
            this.curHref = this.$route.path
        },
        tagId(){
            setTimeout(()=>{
                this.addCacheViewTags()
            },200)
        },
        $route(){
            this.addViewTags()
            this.curHref = this.$route.path
            setTimeout(()=>{
                this.addCacheViewTags()
            },200)
        }
    },
    methods:{
        addCacheViewTags() {
            const { name } = this.$route.meta
            if (name) {
                this.$store.dispatch('addCachedView', {
                    code:this.$route.meta.code,
                    title:this.$route.name,
                    name:name,
					path:this.$route.path
                })
            }
            return false
        },
        addViewTags() {
            this.$store.dispatch('setTagInfo', {
                code:this.$route.meta.code,
                title:this.$route.name,
                name:this.$route.meta.name,
                path:this.$route.path
            })
        },
        resolvePath(routePath) {
	        return path.resolve(routePath)
        },
        removeRoute(path,index,name){
            if (this.curHref.indexOf(path) == 0){
                if (this.tagSet.length > 1){
                    if (index == 0){
                        this.$router.push({ path: this.tagSet[index+1].path });
                    }else{
                        this.$router.push({ path: this.tagSet[index-1].path });
                    }
                }else if (this.tagSet.length == 1){
                    return false
                }
            }
            store.dispatch('removeTagInfo', index);
            store.dispatch('removeCacheView',{name:name})
        }
    }
}
</script>

<style lang="scss" scoped>
.tags{
    width: 100%;
    height: 4.5%;
    background:rgba(39,123,255,0.0984);
    box-shadow: -2px 0px 4px #F2F2F2;
    overflow: hidden;
    .active{
        position: relative;
        height: 100%;
        // border-top: 4px solid rgba(39,123,255,1);
        background:rgba(255,255,255,1);
        // .title{
        //     margin-top: 6px;
        // }
        .hr{
            border: none;
        }
        .blue-hr{
            top: 0;
            position: absolute;
            width: 100%;
            height: 4px;
            background-color: rgba(39,123,255,1)
        }
    }
    .active + li {
        .hr{
            border: none;
        }
    }
    li{
        overflow: hidden;
        float: left;
        height: 100%;
        cursor: pointer;
        display: flex;
        align-items: center;
        img{
            margin-left: 20px;
            width: 15px;
            vertical-align: middle;
            &:hover{
                width: 13px;
                border: 1px dashed #999;/*no*/
            }
        }
        .hr{
            height:16px;
            border: 1px solid #277BFF;
            display: inline-block;
            vertical-align: middle;
            opacity: .5;
            margin-right: 20px;
        }
        .title{
            // margin-top: 10px;
            // height:22px;
            font-size:14px;
            // font-family:PingFangSC-Medium;
            color:rgba(41,48,59,1);
            // line-height:22px;
            text-overflow:ellipsis;
            white-space:nowrap;
            overflow:hidden;
        }
    }
    .no-border{
        border: none !important;
    }
}
// @media screen and (min-width: 1280px) {
//     .tags{
//         .active{
//             height: 50px;
//         }
//     }
// } 
// @media screen and (min-width: 1440px) {
//     .tags{
//         .active{
//             height: 48px;
//         }
//     }
// } 
</style>



// WEBPACK FOOTER //
// src/layout/components/TagsView.vue